import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import ToggleSwitch from 'components/consumer/ToggleSwitch';
const OrderIssueToggleSwitch = t0 => {
  const $ = _c(8);
  const {
    itemId,
    isChecked: t1,
    boughtAsStocked: t2,
    stockDiscount: t3,
    isClearance: t4,
    toggleOrderItem,
    yearsSinceOrderDelivered: t5
  } = t0;
  const isChecked = t1 === undefined ? false : t1;
  const boughtAsStocked = t2 === undefined ? "0" : t2;
  const stockDiscount = t3 === undefined ? 0 : t3;
  const isClearance = t4 === undefined ? false : t4;
  const yearsSinceOrderDelivered = t5 === undefined ? 0 : t5;
  if (boughtAsStocked === "1" && stockDiscount > 0 && isClearance) {
    let t6;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <div className="text-xs pt-4">*Clearance items are not eligible <br /> for warranty service.</div>;
      $[0] = t6;
    } else {
      t6 = $[0];
    }
    return t6;
  }
  if (yearsSinceOrderDelivered < 10) {
    const t6 = `toggle-id-${itemId}`;
    let t7;
    if ($[1] !== itemId || $[2] !== toggleOrderItem) {
      t7 = () => {
        toggleOrderItem(itemId);
      };
      $[1] = itemId;
      $[2] = toggleOrderItem;
      $[3] = t7;
    } else {
      t7 = $[3];
    }
    let t8;
    if ($[4] !== isChecked || $[5] !== t6 || $[6] !== t7) {
      t8 = <ToggleSwitch key={t6} onClick={t7} isChecked={isChecked} size="sm" className="mt-4">I have an issue with this</ToggleSwitch>;
      $[4] = isChecked;
      $[5] = t6;
      $[6] = t7;
      $[7] = t8;
    } else {
      t8 = $[7];
    }
    return t8;
  }
  return null;
};
OrderIssueToggleSwitch.propTypes = {
  itemId: PropTypes.number,
  isChecked: PropTypes.string,
  boughtAsStocked: PropTypes.string,
  stockDiscount: PropTypes.string,
  isClearance: PropTypes.number,
  toggleOrderItem: PropTypes.func,
  yearsSinceOrderDelivered: PropTypes.number
};
export default React.memo(OrderIssueToggleSwitch);